import { SET_THEME_REQUESTED, SET_THEME_COMPLETED } from './types';

// import debug from '../../services/debug';

const setThemeAction = async (themeMode) => async (dispatch) => {
  dispatch({
    type: SET_THEME_REQUESTED,
  });
  return dispatch({
    type: SET_THEME_COMPLETED,
    payload: themeMode,
  });
};

export default setThemeAction;
